const formatPrice = (price) => {
    if (typeof price === 'number') {
        if (Number.isInteger(price))
            return price
        else
            return price.toFixed(2).toString().replace('.', ',')
    }
    else
        return 0;
}

export default formatPrice;